export default `
  query listDemoWorkflows {
    listDemoWorkflows {
      id
      name
      domainEvents {
        cards {
          id
        }
      }
    }
  }
`
